import querystring from "querystring";
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./App.css";
import CreatePlaylistComp from "./components/CreatePlaylist/CreatePlaylistComp";
import Error404 from "./components/Error404/Error404";
import FullNowPlayingComp from "./components/FullNowPlaying/FullNowPlayingComp";
import HeaderComp from "./components/Header/HeaderComp";
import LandingPageComp from "./components/Landing Page/LandingPageComp";
import TopArtistsComp from "./components/TopArtists/TopArtistsComp";
import TopTracksComp from "./components/TopTracks/TopTracksComp";
import MiniNowPlaying from "./components/MinNowPlaying/MiniNowPlaylingComp"

const AppNew = () => {
  //eslint-disable-next-line
  const [serverData, setServerData] = useState({});
  //eslint-disable-next-line
  const [accessToken, setAccessToken] = useState("");
  //eslint-disable-next-line
  const [refreshToken, setRefreshToken] = useState("");

  useEffect(() => {
    const parsed = querystring.parse(window.location.search);
    const accessTokenQ = parsed["?access_token"];
    const refreshToken = parsed.refresh_token;

    // put access/refreshToken in sessionStorage
    if (accessTokenQ) {
      sessionStorage.setItem("accessToken", accessTokenQ);
      sessionStorage.setItem("refreshToken", refreshToken);
    }

    setAccessToken(accessTokenQ);
    setRefreshToken(refreshToken);
    console.log(accessTokenQ)
    const getMe = async (wichAccessToken) => {
      const meRes = await fetch("https://api.spotify.com/v1/me", {
        headers: {
          Authorization: "Bearer " + wichAccessToken
        }
      });
      let meData = await meRes.json();

      //set the important things from /me to state
      setServerData({
        user: {
          id: meData.id,
          name: meData.display_name,
          email: meData.email,
          country: meData.country,
          uri: meData.uri,
          profileimg: meData.images["0"].url
        }
      });
    };
    if (accessTokenQ){
      getMe(accessTokenQ)
    }
  }, []);

  useEffect(() => {
    console.log(accessToken)
  }, [accessToken])

  return (
    <Router>
      <div
        className="app"
        style={{
          display: "grid",
          gridTemplateRows: "auto 1fr",
          minHeight: "100vh",
          alignContent: "center"
        }}
      >
        <HeaderComp />
        <main
          style={{
            display: "grid",
            alignContent: "center",
            padding: "50px 35px 0px 35px"
          }}
        >
          <Switch>
            <Route path="/" exact render={() => <LandingPageComp accessToken={accessToken}/>} />
            <Route path="/nowplaying" render={() => <FullNowPlayingComp accessToken={accessToken}/>} />
            <Route path="/toptracks" render={() => <TopTracksComp accessToken={accessToken}/>} />
            <Route path="/topartists" render={() => <TopArtistsComp accessToken={accessToken}/>} />
            <Route path="/createplaylists" render={() => <CreatePlaylistComp accessToken={accessToken}/>} />
            <Route path="*" component={Error404} />
          </Switch>
          
          {/* <MiniNowPlaying accessToken={accessToken}/> */}
        </main>
      </div>
    </Router>
  );
};

export default AppNew;
